import React, { useMemo } from "react";
import { AlarmIcon } from "../alarm-icon";
import { AlarmFilledIcon } from "../alarm-filled-icon";
import { AppointmentIcon } from "../appointment-icon";
import { AppointmentFilledIcon } from "../appointment-filled-icon";
import { ArrowDownIcon } from "../arrow-down-icon";
import { ArrowRightIcon } from "../arrow-right-icon";
import { ArrowLeftIcon } from "../arrow-left-icon";
import { CalendarIcon } from "../calendar-icon";
import { CalendarFilledIcon } from "../calendar-filled-icon";
import { CheckIcon } from "../check-icon";
import { ChatIcon } from "../chat-icon";
import { DownloadPdfIcon } from "../download-pdf-icon";
import { FileFilledIcon } from "../file-filled-icon";
import { FileIcon } from "../file-icon";
import { FolderIcon } from "../folder-icon";
import { GoBackIcon } from "../go-back-icon";
import { ImageIcon } from "../image-icon";
import { PdfIcon } from "../pdf-icon";
import { PhoneIcon } from "../phone-icon";
import { PlusIcon } from "../plus-icon";
import { SaveIcon } from "../save-icon";
import { SearchIcon } from "../search-icon";
import { SendIcon } from "../send-icon";
import { SettingsIcon } from "../settings-icon";
import { TrashIcon } from "../trash-icon";
import { ThreeDotsIcon } from "../three-dots-icon";
import { UserIcon } from "../user-icon";
import { LogoutIcon } from "../logout-icon";
import { ArrowUpIcon } from "../arrow-up-icon";
import { EqualIcon } from "../equal-icon";
import CloseIcon from "../close-icon";
import { StatsIcon } from "../stats-icon";
import { PanelControlIcon } from "../panel-control-icon";
import { EyeIcon } from "../eye-icon";
import { EyeOffIcon } from "../eye-off-icon";
import { PasswordIcon } from "../password-icon";
import { RectifyIcon } from "../rectify-icon";
import { CreateInvoiceIcon } from "../create-invoice-icon";
import { CreatePreInvoiceIcon } from "../create-pre-invoice-icon";
import { DeleteInvoiceIcon } from "../delete-invoice-icon";
import { ClockIcon } from "../clock-icon";

const iconsMap = {
  alarm: AlarmIcon,
  alarmFilled: AlarmFilledIcon,
  appointment: AppointmentIcon,
  appointmentFilled: AppointmentFilledIcon,
  arrowDown: ArrowDownIcon,
  arrowRight: ArrowRightIcon,
  arrowLeft: ArrowLeftIcon,
  arrowUp: ArrowUpIcon,
  calendar: CalendarIcon,
  calendarFilled: CalendarFilledIcon,
  check: CheckIcon,
  chat: ChatIcon,
  downloadPdf: DownloadPdfIcon,
  fileFilled: FileFilledIcon,
  file: FileIcon,
  folder: FolderIcon,
  goBack: GoBackIcon,
  image: ImageIcon,
  pdf: PdfIcon,
  phone: PhoneIcon,
  plus: PlusIcon,
  save: SaveIcon,
  search: SearchIcon,
  send: SendIcon,
  settings: SettingsIcon,
  trash: TrashIcon,
  threeDots: ThreeDotsIcon,
  user: UserIcon,
  logout: LogoutIcon,
  equal: EqualIcon,
  close: CloseIcon,
  stats: StatsIcon,
  panelControl: PanelControlIcon,
  eye: EyeIcon,
  eyeOff: EyeOffIcon,
  password: PasswordIcon,
  rectify: RectifyIcon,
  createInvoice: CreateInvoiceIcon,
  createPreInvoice: CreatePreInvoiceIcon,
  deleteInvoice: DeleteInvoiceIcon,
  clock: ClockIcon,
};

export const MyIcons = ({ name, className, ...props }) => {
  const IconComponent = useMemo(() => iconsMap[name], [name]);
  return IconComponent ? (
    <IconComponent className={className} {...props} />
  ) : null;
};
